// src/utils/config.ts

// Use environment variables injected by Webpack's DefinePlugin
export const BASE_URL = process.env.BASE_URL;

// Square Payments Configuration (Loaded from environment variables)
export const SQUARE_APPLICATION_ID = process.env.SQUARE_APPLICATION_ID;
export const SQUARE_LOCATION_ID = process.env.SQUARE_LOCATION_ID;
export const SQUARE_ENVIRONMENT = process.env.SQUARE_ENVIRONMENT; // 'sandbox' or 'production'

// PostHog Configuration (Loaded from environment variables)
export const POSTHOG_API_KEY = process.env.POSTHOG_API_KEY;
export const POSTHOG_API_HOST = process.env.POSTHOG_API_HOST;

// Sentry Configuration (Loaded from environment variables). If SENTRY_DSN is
// empty the bundled Sentry initializer becomes a no-op (see utils/sentry.ts).
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.SENTRY_ENVIRONMENT;
export const APP_ENV = process.env.APP_ENV;
export const COMPETITION_CATALOGUE_ENV = process.env.COMPETITION_CATALOGUE_ENV;

// Other constants
export const DEFAULT_COOKIE_EXPIRY_DAYS = 30;
// Brief expiry used when restoring a stashed temp JWT immediately before an
// auth action (login/signup). The backend replaces it on success, so a short
// window is intentional here.
export const TEMP_USER_COOKIE_EXPIRY_HOURS = 1;
// Matches the backend voucher-claim Set-Cookie expiry for `is_temporary`
// (see service/backend/vouchers/router.py). Used by persistAuthToken when the
// voucher claim returns a temp-user JWT so the JS-set cookie doesn't shorten
// the temp window the backend just granted.
export const TEMP_USER_DEFAULT_EXPIRY_HOURS = 24;
export const ENTRY_FORM_COOKIE_EXPIRY_MINUTES = 5;
export const RECORDING_READY_CHECK_INTERVAL_MS = 5000;
export const RECORDING_READY_MAX_RETRIES = 30;
export const HOLE_IN_ONE_CLAIM_WINDOW_HOURS = 24; // Or 7 days? JS used 24 hours check
export const FEEDBACK_MODAL_COOLDOWN_DAYS = 7;
